import Schema from 'async-validator'
export const validField = (rule, value, callback) => {
  const validator = new Schema({value: rule})
  validator.validate({value}, errors => callback(errors ? rule.message : null))
}



// WEBPACK FOOTER //
// ./src/packages/utils/valid.js